import { useState } from "react";
import { Document, Page, pdfjs } from "react-pdf";
import PropTypes from "prop-types";
import "react-pdf/dist/Page/AnnotationLayer.css";
import "react-pdf/dist/Page/TextLayer.css";

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

/**
 * Renders all pages of a PDF file using react-pdf.
 *
 * @param {object} props
 * @param {string} [props.url] - Direct URL to the PDF file.
 */
const PdfPreview = ({ url }) => {
  const [numPages, setNumPages] = useState(null);

  return (
    <div className="overflow-y-auto flex flex-col items-center gap-3">
      <Document
        file={url}
        onLoadSuccess={({ numPages: total }) => setNumPages(total)}
        loading="Cargando PDF..."
        error="Error al cargar el PDF."
      >
        {numPages &&
          Array.from({ length: numPages }, (_, i) => (
            <Page key={`page_${i + 1}`} pageNumber={i + 1} width={720} />
          ))}
      </Document>
    </div>
  );
};

PdfPreview.propTypes = {
  url: PropTypes.string,
};

export default PdfPreview;
